import { DateTime } from 'luxon';
import React from 'react';
import type { LoaderFunction } from "react-router";
import { useLoaderData, useLocation, useNavigate, useNavigation, useParams } from 'react-router-dom';
import { Button } from 'reactstrap';
import { deleteLogById, getLogById } from '../../shared/client';
import { Log } from '../../shared/log';
import Loader from '../../ui/Loader';
import { useLogContext } from '../../shared/log-context';
import { useConfirmationModalContext } from '../../shared/useConfirm';

export const loader: LoaderFunction = async ({ request, params }) => {    
    const logId = params["logId"] as string;
    const module = params["module"] as string;
    return await getLogById(logId,module);
}

export const LogDetailsOnly: React.FC<{ log: Log }> = ({ log }) => {
    const { getAppName, getProfileName} = useLogContext(); 

    return (
        <>
            <p id="pnlLevel">Log Level : {log?.level}</p>
            <p id="pnlDateTime">Date and Time  : {DateTime.fromISO(log?.dateTime ?? "").toFormat('ff')}</p>
            <p id="pnlUserName">Machine Name  : {log?.machineName}</p>
            <p id="pnlApplication">Application : {getAppName(Number(log?.applicationId))}</p>
            <p id="pnlUserId">User  : {log?.userId} / {log?.userName}</p>
            <p id="pnlUserAgent">UserAgent  : {log?.userAgent}</p>
            <p id="pnlIP">IP  : {log?.ip}</p>
            <p id="pnlProfile">Profile  : {getProfileName(Number(log?.applicationId),Number(log?.profile))}</p>
            <p id="pnlUrl">Url  : {log?.url}</p>
            <p id="pnlMessage">Message  : {log?.message}</p>
            <p id="pnlException">Exception  : {log?.exception}</p>
            <p id="pnlStackTrace">StackTrace  : {log?.stackTrace}</p>
            <p id="pnlInnerException">InnerException  : {log?.innerErrorMessage}</p>
            <p id="pnlCallSite">CallSite  : {log?.callSite}</p>
            <div id="pnlAllXml">AllXml  : <div dangerouslySetInnerHTML={{ __html: log?.allXml ?? "" }} /></div>
        </>
    )
} 

const LogDetails: React.FC<{ }> = (props) => { 
    const modalContext = useConfirmationModalContext();
    const location = useLocation();    
    const navigate = useNavigate();
    const {module, logId } = useParams();
    const navigation = useNavigation();
    const log = useLoaderData() as Log;

    React.useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const onLogDelete = async (e: React.MouseEvent, logId: string) => {
        e.preventDefault();
        const result = await modalContext.showConfirmation(
                        'Delete Confirmation!',
                        <div>
                            Are you sure you want to delete log?
                        </div>
                    );
        
                    
        if (result) {
            const success = await deleteLogById(logId, module??"");
            if (success) {
                navigate(`/${module??""}/log/list`);
            }  
        } 
    }
    
    const onCancel = () => {
        navigate(`/${module??""}/log/list`);
    }

    if (!log) {
        return <Loader />
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-12">                    
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <LogDetailsOnly log={log}/>                           
                        </div>                       
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        <Button className="btn btn-danger" onClick={(e) => onLogDelete(e, log.id)}>Delete</Button>
                        <Button type="button" className="btn btn-info" onClick={(e) => onCancel()}>Cancel</Button>                        
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LogDetails;